import { render, staticRenderFns } from "./ImportarBackup.vue?vue&type=template&id=676be569&scoped=true"
import script from "./ImportarBackup.vue?vue&type=script&lang=js"
export * from "./ImportarBackup.vue?vue&type=script&lang=js"
import style0 from "./ImportarBackup.vue?vue&type=style&index=0&id=676be569&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676be569",
  null
  
)

export default component.exports